import { usePrivilegesStore } from "@/stores/privileges";

const DEFAULT_DENIED = "You do not have permission to perform this action.";

/**
 * If the current user lacks the privilege, show a browser alert and return false.
 * Otherwise return true. Use at the start of click / submit handlers.
 *
 * @param {number} privilegeId  From PRIVILEGES in @/constants/privileges
 * @param {string} [message]    Optional custom alert text
 * @returns {boolean}
 */
export function assertPrivilegeOrAlert(privilegeId, message = DEFAULT_DENIED) {
  const store = usePrivilegesStore();
  if (!store.effectiveGranted(privilegeId)) {
    alert(message);
    return false;
  }
  return true;
}
